import { ValidationSchema } from './validation';

export function getValidationSchemaForFields(fields, params) {
    return new ValidationSchema(fields, params);
}
